import React, { useState } from 'react';
import { Button, Col, FormGroup, Row } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../context';
import { Form, Field } from 'react-final-form';
import createDecorator from 'final-form-calculate';
import { OnChange } from 'react-final-form-listeners';
import BtxSwitch from '../Forms/BtxSwitch';

const calculator = createDecorator({
    field: 'partnerId',
    updates: {
        partnerOfferingId: (value, allValues) => {},
    },
});

function EditPracticeRelationsForm(props) {
    const {
        isEdit = false,
        practiceId,
        submitCB = () => {},
        closeCB = () => {},
        selectedOffering = {},
    } = props;

    const dispatch = useDispatch();
    // TODO: do proper diffing
    const availableRelations = useSelector(state => state.offering.availableOfferings, shallowEqual);

    const [convertAttachments, setConvertAttachments] = useState(
        selectedOffering?.convertAttachments
    );
    const [isWorking, setIsWorking] = useState(false);

    const saveOffering = async (values) => {
        setIsWorking(true);
        let saveOrUpdate;
        let customId = (values.customPartnerId) ? values.customPartnerId : '';
        if (isEdit) {
            saveOrUpdate = dispatch(
                actions.relations.updateRelation(
                    practiceId,
                    values.partnerOfferingId,
                    customId,
                    convertAttachments
                )
            );
        } else {
            saveOrUpdate = dispatch(
                actions.relations.saveRelation(
                    practiceId,
                    values.partnerOfferingId,
                    customId,
                    convertAttachments
                )
            );
        }
        saveOrUpdate.then(() => {
            Promise.all([
                dispatch(actions.relations.fetchRelations(practiceId)),
                dispatch(actions.notes.fetchNotes(practiceId)),
                dispatch(actions.toggle.triggerRefresh()),
                dispatch(actions.toggle.triggerPracticeRefresh()),
                dispatch(actions.toggle.activitiesRefresh()),
            ]).then(() => {
                setIsWorking(false);
                submitCB();
            });
        });
    };

    const getPartnerList = availableRelations.map((partner, index) => {
        return (
            <option key={index} name={partner.name} value={partner.id}>
                {partner.name}
            </option>
        );
    });

    const toggleConvertAttchments = () =>
        setConvertAttachments(!convertAttachments);

    const checkOfferingIsConversion = (partnerOfferingId = '') => {
        if (selectedOffering?.isConversionOffering) return true;
        if (!partnerOfferingId) return false;
        let conversionIds = availableRelations.map((relation) => {
            let conversionId = relation?.offerings.map((offering) => {
                return offering.isConversionOffering && offering.id;
            });
            return (conversionId = conversionId.filter((x) => x));
        });
        return conversionIds.flat().includes(partnerOfferingId);
    };

    const disabledCheck = (submitting, pristine) =>
        !isEdit && (submitting || pristine) && isWorking;

    const decorators = isEdit ? [] : [calculator];

    return (
        <Form
            initialValues={{ ...selectedOffering }}
            onSubmit={saveOffering}
            decorators={decorators}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form
                    id="editPracticeRelations"
                    onSubmit={handleSubmit}
                    className="w-100">
                    <FormGroup row>
                        <Col>
                            <label htmlFor="partner" className="d-block">
                                Partner
                                <br />
                                <Field
                                    id="partner"
                                    name="partnerId"
                                    component="select"
                                    className="w-100 p-2 rounded"
                                    required
                                    disabled={isEdit}>
                                    <option value="">
                                        --= Please Select A Partner =--
                                    </option>
                                    {getPartnerList}
                                </Field>
                            </label>
                        </Col>
                    </FormGroup>
                    <OnChange name="partnerId">
                        {(value) => {
                            setConvertAttachments();
                        }}
                    </OnChange>
                    {values?.partnerId && (
                        <FormGroup row>
                            <Col>
                                <label htmlFor="offering" className="d-block">
                                    Offering
                                    <br />
                                    <Field
                                        id="offering"
                                        name="partnerOfferingId"
                                        component="select"
                                        className="w-100 p-2 rounded"
                                        required
                                        disabled={isEdit}>
                                        {values.partnerId && (
                                            <option value="" />
                                        )}
                                        {availableRelations
                                            .filter(
                                                (p) => p.id === values.partnerId
                                            )?.[0]
                                            ?.offerings.map(
                                                (offering, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            name={offering.name}
                                                            value={offering.id}>
                                                            {offering.name}
                                                        </option>
                                                    );
                                                }
                                            )}
                                    </Field>
                                </label>
                            </Col>
                        </FormGroup>
                    )}
                    {values.partnerId && values.partnerOfferingId && (
                        <FormGroup row>
                            <Col>
                                <label
                                    htmlFor="customPartnerId"
                                    className="d-block">
                                    Partner Custom Id
                                    <br />
                                    <Field
                                        id="customPartnerId"
                                        name="customPartnerId"
                                        component="input"
                                        className="w-100 p-2 rounded border-0"
                                    />
                                </label>
                            </Col>
                        </FormGroup>
                    )}
                    {values.partnerId &&
                        checkOfferingIsConversion(
                            values?.partnerOfferingId
                        ) && (
                            <FormGroup row>
                                <Col>
                                    <label
                                        htmlFor="convertAttachemnts"
                                        className="d-flex justify-content-between align-items-center">
                                        <span className="w-100">
                                            Convert Practice Attachments
                                        </span>
                                        <BtxSwitch
                                            id="convertAttachemnts"
                                            name="convertAttachemnts"
                                            value={convertAttachments}
                                            className="text-right"
                                            onChange={toggleConvertAttchments}
                                        />
                                    </label>
                                </Col>
                            </FormGroup>
                        )}
                    <Row className="justify-content-end pt-3">
                        <Button
                            color="danger"
                            className="mr-3"
                            disabled={isWorking}
                            onClick={closeCB}>
                            Cancel
                        </Button>
                        <Button
                            color="success"
                            type="submit"
                            disabled={disabledCheck(submitting, pristine)}>
                            Save
                        </Button>
                    </Row>
                </form>
            )}
        />
    );
}

export default EditPracticeRelationsForm;
